import { useState } from "react";
import { useParams, useSearch } from "@tanstack/react-router";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Server State
import { useEntitlementCard } from "../../state/entitlementCardState";
// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import EntitlementLines from "./EntitlementLines";
// MUI imports
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function EntitlementCard() {
  const { id } = useParams({ strict: false });

  const { type = null } = useSearch({ strict: false });

  // Staff Entitlement Details
  const [entitlement, setEntitlement] = useState({
    filter: {},
    staff: {},
    entitlement: [],
  });

  const { isPending, isError, isSuccess, error, data } = useEntitlementCard(
    id,
    type,
  );

  // Success Function
  const successFunc = () => {
    setEntitlement(data.data.data.data.list);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      {isError && <Typography>Error: {error.message}</Typography>}
      <GenericListHeader
        heading={`Entitlement - ${entitlement.staff?.name} (${entitlement.staff?.no})`}
      />
      <Box>
        {entitlement.entitlement ? (
          <Box sx={{ pt: 1 }}>
            <EntitlementLines entitlementLines={entitlement.entitlement} />
          </Box>
        ) : (
          !isPending && <Typography>No Data</Typography>
        )}
      </Box>
    </>
  );
}

// {
//     "status": 200,
//     "statusText": "OK",
//     "data": {
//         "data": {
//             "list": {
//                 "filter": {
//                     "staffId": "STA142784"
//                 },
//                 "staff": {
//                     "no": "STA142784",
//                     "name": "Creation Test1"
//                 }
//             }
//         }
//     }
// }
